export function getErrorMessage(e) {
  // axios error response
  const d = e?.response?.data;

  // backend plain string qaytarırsa
  if (typeof d === "string") return d;

  // Identity errors array: [{ code, description }, ...]
  if (Array.isArray(d)) {
    const msg = d
      .map((x) => x?.description || x?.Description || x?.code || x?.Code)
      .filter(Boolean)
      .join("\n");
    return msg || JSON.stringify(d, null, 2);
  }

  // backend object qaytarırsa (ProblemDetails, {message}, {errors} və s.)
  if (d && typeof d === "object") {
    if (typeof d.message === "string") return d.message;
    if (typeof d.title === "string") return d.title;
    if (typeof d.detail === "string") return d.detail;

    // ASP.NET ModelState: { errors: { Field: [..] } }
    if (d.errors && typeof d.errors === "object") {
      const msgs = [];
      for (const k of Object.keys(d.errors)) {
        const arr = d.errors[k];
        if (Array.isArray(arr)) arr.forEach((m) => msgs.push(`${k}: ${m}`));
      }
      if (msgs.length) return msgs.join("\n");
    }

    return JSON.stringify(d, null, 2);
  }

  // fallback
  return e?.message || "Request failed";
}
